const en = {
    title: 'Sign in',
    description: 'Your storage and files in one place.',
    login: 'Login',
    password: 'Password',
    submit: 'Sign in',
    pending: 'Signing in…',
    language: 'Language / Язык',
    invalidCredentials: 'Invalid login or password.',
    rateLimited: 'Too many sign-in attempts. Please try again later.',
    unavailable: 'Unable to sign in. Please try again later.',
    invalidSession: 'Unable to verify your session. Please try again.',
    network: 'Unable to reach the server. Check your connection and try again.',
    timeout: 'The server took too long to respond. Please try again.',
}

const ru: Record<keyof typeof en, string> = {
    title: 'Вход',
    description: 'Ваши хранилища и файлы в одном месте.',
    login: 'Логин',
    password: 'Пароль',
    submit: 'Войти',
    pending: 'Входим…',
    language: 'Language / Язык',
    invalidCredentials: 'Неверный логин или пароль.',
    rateLimited: 'Слишком много попыток входа. Повторите позже.',
    unavailable: 'Не удалось войти. Попробуйте позже.',
    invalidSession: 'Не удалось подтвердить сессию. Попробуйте ещё раз.',
    network: 'Сервер недоступен. Проверьте подключение и попробуйте ещё раз.',
    timeout: 'Сервер отвечает слишком долго. Попробуйте ещё раз.',
}

export const messages = { en, ru }
